import '../../../less/ss-common-data.less';
import '../../../less/ss-common-data-ie.less';
import '../../../less/ss-application-guide.less';
import PDFViewer from '@bit/ui-common.ui-components/ss-common-data/react/components/pdf-viewer/PDFViewer';
import { getPathParams } from '@bit/ui-common.ui-components/ss-utils/utils/commonUtils';
import { Collapse, Card, Row, Col, Divider } from 'antd';
import { injectLinkConfig } from '../../../utils/helpUtils'
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

export default class HelpData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPDF: null,
            defaultHasButtons: false,
            isHovered: null,
        }
    };

    getNoticeContainerSize = () => {
        const { space } = this.props;
        switch (space) {
            case 'lg': return 'ss-notice-container-lg';
            case 'xl': return 'ss-notice-container-xl';
            case 'home-page': return 'ss-notice-container-home-page';
            case 'popover': return 'ss-notice-container-popover';
            default: return 'ss-notice-container';
        }
    }

    getNoticeContainerTheme = () => {
        const
            { theme } = this.props,
            lightClasses = {
                container: 'ss-site-notice-container-light',
                noticeContainer: 'ss-notice-list-container-light',
                noticeHeader: 'ss-notice-container-header-light',
                notice: 'ss-site-notice-entry'
            };

        switch (theme) {
            case 'light': return lightClasses;

            case 'dark': return {
                container: 'ss-site-notice-container-dark',
                noticeContainer: 'ss-notice-list-container-dark',
                noticeHeader: 'ss-notice-container-header-dark',
                notice: 'ss-site-notice-entry'
            }

            default: return lightClasses;
        }
    }

    getNoticeTitle = () => {
        const { space, theme } = this.props;
        let styleClass = '';

        switch (space) {
            case 'xl': styleClass += 'ss-notice-title-xl'; break;
            case 'home-page': styleClass += 'ss-notice-title-home-page'; break;
            case 'popover': styleClass += 'ss-notice-title-popover'; break;
            default: styleClass += 'ss-notice-title';
        }

        styleClass += ' ';
        switch (theme) {
            case 'light': styleClass += 'ss-notice-title-theme-light'; break;
            case 'dark': styleClass += 'ss-notice-title-theme-dark'; break;
            default: styleClass += 'ss-notice-title-theme-light';
        }

        return styleClass;
    }

    getNoticeBody = () => {
        const { space, theme } = this.props;
        let styleClass = '';

        switch (space) {
            case 'xl': styleClass += 'ss-notice-body-xl'; break;
            case 'lg': styleClass += 'ss-notice-body-lg'; break;
            case 'home-page': styleClass += 'ss-notice-body-home-page'; break;
            case 'popover': styleClass += 'ss-notice-body-popover'; break;
            default: styleClass += 'ss-notice-body-normal';
        }

        styleClass += ' ';
        switch (theme) {
            case 'light': styleClass += 'ss-notice-body-theme-light'; break;
            case 'dark': styleClass += 'ss-notice-body-theme-dark'; break;
            default: styleClass += 'ss-notice-body-theme-light';
        }

        return styleClass;
    }

    handleMouseEnter = (files) => {
        this.setState({isHovered: files});
    }

    handleMouseLeave = () => {
        this.setState({isHovered: null});
    }

    handlePick = (pdfFilePath) => {
        this.setState({ selectedPDF: pdfFilePath })
    }

    handleButtons = () => {
        const { pdfs } = this.props

        return pdfs.map((buttonPdf) => {
           
            return <button 
                    style= {{paddingRight:'2%', paddingLeft:'2%', color: this.state.isHovered == buttonPdf.filePath ? 'orange' : this.state.selectedPDF == buttonPdf.filePath ? 'red':'darkBlue'}} 
                    key={buttonPdf.filePath} 
                    className='not-button' 
                    onClick={() => this.handlePick(buttonPdf.filePath)}
                    onMouseEnter={() => this.handleMouseEnter(buttonPdf.filePath)}
                    onMouseLeave={this.handleMouseLeave}
                    >| {buttonPdf.fileName} |</button>           
        })
    }

    render() {
        const
        { title, space, theme, pdfs, defaultPdf} = this.props,
        noticesClasses = this.getNoticeContainerTheme();

        let namedDest;
        const params = getPathParams();
        if (params != null && params.namedDest != null) {
            namedDest = params.namedDest;
        }

        return (
            <div className={this.getNoticeContainerSize()}>
                <div className={this.getNoticeTitle()}> { title } </div>
                <div className={this.getNoticeBody()} style={{ padding: '0' }}>
                    <div className='infoSection' style={{ height: '100%', paddingTop: '0', textAlign: 'center', color: 'darkblue', border: 'none' }}>
                        <div>
                            {pdfs.length > 0 && (
                            <div className='ss-notice-content' style={{ marginTop: '2%' }}>
                                {this.handleButtons()}
                            </div>)}                           
                        </div>
                        <div style={{ height: '100%' }}>
                            {this.state.selectedPDF ? (
                                <PDFViewer
                                    filePath={this.state.selectedPDF}
                                    space='home-page-FAQ'
                                    options={{
                                        toolbar: 1,
                                        nameddest: namedDest,
                                    }}
                                />
                            ) : (
                                <PDFViewer
                                    filePath={defaultPdf}
                                    space='home-page-FAQ'
                                    options={{
                                        toolbar: 1,
                                        nameddest: namedDest,
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}